import { UserRole } from '../../../core/auth/user-role';
import { Iri } from '../../../core/dto/iri';

export function hasRequiredRoles(roles: string[]): boolean {
    return roles.includes(UserRole.ROLE_ADMIN);
}

export function canEditPerson(person: Iri, user: Iri, userRoles: string[]) {
    return person === user || hasRequiredRoles(userRoles);
}
